import React from 'react'
import injectSheet from 'react-jss'
import {
  TitleContainer,
  IconTile,
  LinkButton,
  ListTile,
  ListTileItem,
} from '../../'

const Plot = (props) => {
  const {
    classes,
    history,
    plot,
    setBudgetBlock,
    togglePlot,
    selection,
  } = props

  const goToBudget = (node) => {
    if (node !== selection) {
      history.push('/budget')
    }
  }

  return (
    <TitleContainer
      className={`${classes.container}`}
      title={plot.config.title}
    >
      <ListTile>
        {plot.nodes && Array.isArray(plot.nodes) && plot.nodes.map((node, index) => (
          <ListTileItem
            key={`element-${node.id}`}
            index={index}
            length={plot.nodes.length}
          >
            <IconTile
              key={`plot-${node.id}`}
              activeNode={plot.config}
              handleClick={() => {
                setBudgetBlock(node.value)
                togglePlot(node.value)
                goToBudget(node.value)
              }}
              index={index}
              isSelected={node.value === selection}
              node={node}
            />
          </ListTileItem>
        ))}
      </ListTile>
      {plot.linkTile && (
        <div className={classes.linkTile}>
          <div className={classes.linkDescription}>
            <p>{plot.linkTile.linkDescription}</p>
          </div>
          <div className={classes.linkButton}>
            <LinkButton
              href={plot.linkTile.linkUrl}
              text={plot.linkTile.linkButton}
              external
              primary
            />
          </div>
        </div>
      )}
    </TitleContainer>
  )
}

const styles = theme => ({
  container: {
    height: '100%',
  },
  linkTile: {
    width: `calc(${100}% - ${theme.sizes.gutter}px)`,
    margin: `${theme.sizes.gutter / 2}px`,
    padding: `${theme.sizes.gutter}px`,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    backgroundColor: theme.colors.main_2,
  },
  linkDescription: {
    width: '100%',
    padding: `${theme.sizes.gutter / 2}px 0`,
    textAlign: 'center',
    color: theme.colors.main_3,
  },
})


export default injectSheet(styles)(Plot)



// WEBPACK FOOTER //
// ./src/modules/plot/components/plot.jsx